// Alert devtools mock data
import {
  InsuranceBillAlert,
  Alerts,
  PaymentMethodAlert,
} from "../types/Alerts.types";
import { ESignDocument } from "../types/ESignDocument.types";

const insuranceCoreAutopayFailed: InsuranceBillAlert[] = [
  {
    source: "core",
    policyNumber: "abc123",
    state: "CA",
    country: "USA",
  },
];

const insuranceApexAutopayFailed: InsuranceBillAlert[] = [
  {
    source: "apex",
    policyNumber: "en01",
    state: "MI",
    country: "USA",
  },
];

const insuranceAutopayFailed: InsuranceBillAlert[] = [
  ...insuranceCoreAutopayFailed,
  ...insuranceApexAutopayFailed,
];

const insuranceCoreBillPastDue: InsuranceBillAlert[] = [
  {
    source: "core",
    policyNumber: "def456",
    state: "OR",
    country: "USA",
  },
];

const insuranceApexBillPastDue: InsuranceBillAlert[] = [
  {
    source: "apex",
    policyNumber: "en02",
    state: "IL",
    country: "USA",
  },
];

const insuranceBillPastDue: InsuranceBillAlert[] = [
  ...insuranceCoreBillPastDue,
  ...insuranceApexBillPastDue,
];

const eSignDocuments: ESignDocument[] = [
  {
    id: 1,
    source: "usa",
    state: "KS",
  },
  {
    id: 2,
    source: "canada",
    state: "OK",
  },
];

const paymentMethodAlertCore: PaymentMethodAlert[] = [
  {
    source: "core",
    policyNumber: "abc123",
    last4: "1234",
    cardType: "Visa",
  },
];

const paymentMethodAlertApex: PaymentMethodAlert[] = [
  {
    source: "apex",
    policyNumber: "en02",
    last4: "5678",
    cardType: "Mastercard",
  },
];

const paymentMethodAlert: PaymentMethodAlert[] = [
  ...paymentMethodAlertCore,
  ...paymentMethodAlertApex,
];

export const insuranceCoreAutopayAlertMock: Alerts = {
  insuranceAutopayFailed: insuranceCoreAutopayFailed,
};

export const insuranceApexAutopayAlertMock: Alerts = {
  insuranceAutopayFailed: insuranceApexAutopayFailed,
};

export const insuranceAutopayAlertMock: Alerts = {
  insuranceAutopayFailed,
};

export const insuranceCoreBillPastDueMock: Alerts = {
  insuranceBillPastDue: insuranceCoreBillPastDue,
};

export const insuranceApexBillPastDueMock: Alerts = {
  insuranceBillPastDue: insuranceApexBillPastDue,
};

export const insuranceBillPastDueMock: Alerts = {
  insuranceBillPastDue,
};

export const hdcAutopayAlertMock: Alerts = {
  hdcAutopayFailed: true,
};

export const hdcBillPastDueMock: Alerts = {
  hdcBillPastDue: true,
};

export const eSignMock: Alerts = {
  eSignDocuments: [eSignDocuments[0]],
};

export const twoEsignMock: Alerts = {
  eSignDocuments,
};

export const twoEsignInsuranceAutopayFailureHdcLatePaymentMock: Alerts = {
  insuranceAutopayFailed,
  hdcBillPastDue: true,
  eSignDocuments: eSignDocuments,
};

export const paymentMethodExpiredCore: Alerts = {
  paymentMethodExpired: paymentMethodAlertCore,
};

export const paymentMethodExpiredApex: Alerts = {
  paymentMethodExpired: paymentMethodAlertApex,
};

export const paymentMethodExpired: Alerts = {
  paymentMethodExpired: paymentMethodAlert,
};

export const paymentMethodExpiringCore: Alerts = {
  paymentMethodExpiring: paymentMethodAlertCore,
};

export const paymentMethodExpiringApex: Alerts = {
  paymentMethodExpiring: paymentMethodAlertApex,
};

export const paymentMethodExpiring: Alerts = {
  paymentMethodExpiring: paymentMethodAlert,
};

export const mockAlerts: Alerts[] = [
  {}, // no alerts
  insuranceCoreAutopayAlertMock,
  insuranceApexAutopayAlertMock,
  insuranceAutopayAlertMock,
  insuranceCoreBillPastDueMock,
  insuranceApexBillPastDueMock,
  insuranceBillPastDueMock,
  hdcAutopayAlertMock,
  hdcBillPastDueMock,
  eSignMock,
  twoEsignMock,
  twoEsignInsuranceAutopayFailureHdcLatePaymentMock,
  paymentMethodExpiredCore,
  paymentMethodExpiredApex,
  paymentMethodExpired,
  paymentMethodExpiringCore,
  paymentMethodExpiringApex,
  paymentMethodExpiring,
];
